var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-wrap"},[_c('div',{staticClass:"dialog-detail"},[(_vm.isShowClose)?_c('img',{staticClass:"close",attrs:{"src":require("../assets/img/close.png")},on:{"click":_vm.close}}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }